export const AUTOMATION_EVENTS = ['issue.created', 'comment.created', 'issue.status_changed'];
/**
 * These are receiver endpoints, never arbitrary URLs or Zap/Scenario editor URLs.
 * Shared so the dashboard's Zapier and Make dialogs refuse a URL for the other
 * tool with the same rule the server saves by (2026-10-18).
 */
export function parseAutomationDestination(value) {
    let url;
    try {
        url = new URL(value.trim());
    }
    catch {
        throw new Error('Paste a Zapier Catch Hook or Make Custom Webhook URL.');
    }
    if (url.protocol !== 'https:' || url.username || url.password || url.port || url.hash || url.search) {
        throw new Error('Use the original HTTPS webhook URL, without extra parameters.');
    }
    if (url.hostname === 'hooks.zapier.com' && /^\/hooks\/catch\/[a-zA-Z0-9_-]+\/[a-zA-Z0-9_-]+\/?$/.test(url.pathname)) {
        return { url: url.href, provider: 'zapier' };
    }
    if (/^hook\.(?:eu|us)\d+\.make\.com$/.test(url.hostname) && /^\/[a-zA-Z0-9_-]+\/?$/.test(url.pathname)) {
        return { url: url.href, provider: 'make' };
    }
    throw new Error('Paste a Zapier Catch Hook or Make Custom Webhook URL.');
}
//# sourceMappingURL=automations.js.map